/* Based on the Early-Game Win Probability Calculator by Oracle's Elixir */

const data = {
  chemtechDiff: -0.0372125,
  cloudDiff: 0.402313,
  gameCount: 726,
  goldDiff: 0.000607005,
  hextechDiff: 0.341735,
  infernalDiff: 0.364385,
  mountainDiff: 0.274606,
  oceanDiff: 0.377887,
  side: -0.218235,
  split: "2025",
  updatedAt: "2025-05-05T14:12:22.000Z"
}

export const calculateOdds = (blueTeam, redTeam) => {
  const side = -1 // We calculate for blue side
  const goldDiff = blueTeam.totalGold - redTeam.totalGold
  const [infernalDiff, mountainDiff, oceanDiff, cloudDiff, chemtechDiff, hextechDiff] = [
    'infernal',
    'mountain',
    'ocean',
    'cloud',
    'chemtech',
    'hextech',
  ].map(
    (type) =>
      blueTeam.dragons.filter((d) => d === type).length -
      redTeam.dragons.filter((d) => d === type).length
  )

  const logOdds =
    side * data.side +
    goldDiff * data.goldDiff +
    infernalDiff * data.infernalDiff +
    mountainDiff * data.mountainDiff +
    oceanDiff * data.oceanDiff +
    cloudDiff * data.cloudDiff +
    chemtechDiff * data.chemtechDiff +
    hextechDiff * data.hextechDiff

  const odds = 2.71828182845904523536 ** logOdds
  const winProbability = (odds / (1 + odds)) * 100

  return winProbability
}
